"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThumbsIconButton = exports.THUMBS_UP_ICON = exports.THUMBS_DOWN_ICON = exports.StyledThumbsIconButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Icon = require("../Icon");

var _Icons = require("../Icons");

var StyledThumbsIconButton = (0, _styledComponents.default)('button').withConfig({
  displayName: "ThumbsIconButton__StyledThumbsIconButton",
  componentId: "sc-1aqwm0p-0"
})({
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ':disabled': {
    pointerEvents: 'none',
    boxShadow: 'none',
    cursor: 'not-allowed'
  },
  whiteSpace: 'nowrap'
}, (0, _styledSystem.variant)({
  prop: 'rounded',
  variants: {
    true: {
      borderRadius: 7,
      padding: 2
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'selected',
  variants: {
    false: {
      color: 'sonar',
      backgroundColor: 'durian',
      ':hover': {
        backgroundColor: 'langsat'
      },
      ':active': {
        backgroundColor: 'langsat'
      }
    },
    true: {
      color: 'coco',
      backgroundColor: 'rambutan',
      ':hover': {
        backgroundColor: 'variants.rambutan.light'
      },
      ':active': {
        backgroundColor: 'variants.rambutan.light'
      }
    }
  }
}));
exports.StyledThumbsIconButton = StyledThumbsIconButton;
var THUMBS_DOWN_ICON = 'THUMBS_DOWN_ICON';
exports.THUMBS_DOWN_ICON = THUMBS_DOWN_ICON;
var THUMBS_UP_ICON = 'THUMBS_UP_ICON';
exports.THUMBS_UP_ICON = THUMBS_UP_ICON;

var ThumbsIconButton = function ThumbsIconButton(_ref) {
  var _THUMBS_DOWN_ICON$THU;

  var icon = _ref.icon,
      props = (0, _objectWithoutProperties2.default)(_ref, ["icon"]);
  return _react.default.createElement(StyledThumbsIconButton, (0, _extends2.default)({
    role: "button",
    type: "button",
    rounded: true
  }, props), _react.default.createElement(_Icon.IconForm, {
    fontSize: [7, 7, 7]
  }, (_THUMBS_DOWN_ICON$THU = {}, (0, _defineProperty2.default)(_THUMBS_DOWN_ICON$THU, THUMBS_DOWN_ICON, _react.default.createElement(_Icons.ThumbsDown, null)), (0, _defineProperty2.default)(_THUMBS_DOWN_ICON$THU, THUMBS_UP_ICON, _react.default.createElement(_Icons.ThumbsUp, null)), _THUMBS_DOWN_ICON$THU)[icon]));
};

exports.ThumbsIconButton = ThumbsIconButton;
ThumbsIconButton.defaultProps = {
  selected: false
};